$(function () {
    $('#contactModal form').on('apiSuccess', function (e, data) {
        const $form = $(this);

        $form.replaceWith(`
            <div class="alert alert-success text-center">
                <div class="fs-3 fw-bold">Message Sent</div>
                <div>We will get back to you as soon as possible</div>
                <div class="mt-2"><button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal" aria-label="Close">Close</button></div>
            </div>
        `);
    });

    $(document)
        .on('shown.bs.modal', '.modal', function () {
            if (typeof turnstile === 'undefined') return;
            $(this).find('.cf-turnstile-container').each(function () {
                if (this.dataset.widgetId) return;            // already rendered
                this.dataset.widgetId = turnstile.render(this, {
                    sitekey: window.CLOUDFLARE_TURNSTILE_SITEKEY,
                    theme: this.dataset.theme || 'light'
                });
            });
        })
        .on('hidden.bs.modal', '.modal', function () {
            if (typeof turnstile === 'undefined') return;
            $(this).find('.cf-turnstile-container').each(function () {
                if (this.dataset.widgetId) {
                    turnstile.remove(this.dataset.widgetId);
                    delete this.dataset.widgetId;
                }
            });
        });

});
